<template>
  <div>
    <div class="crumbs">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>
          <i class="el-icon-s-order"></i> 日志列表
        </el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="main_box">
      <!-- 顶部的盒子 -->
      <div class="top_box">
        <el-button type="primary" size="mini" icon="el-icon-circle-plus-outline" @click="addLog">新增日志</el-button>
        <el-input v-model="searchKey" clearable size="mini" placeholder="输入关键字搜索"
          @change="searchKeyChange(tableData,searchKey)">
          <el-button slot="append" icon="el-icon-search" @click="searchKeyChange(tableData,searchKey)"></el-button>
        </el-input>
      </div>
      <!--表格-->
      <div class="table_box">
        <el-table :data="tableDataEnd" @sort-change="onSortChange">
          <el-table-column label="序号" align="center" type="index" width="80"></el-table-column>
          <el-table-column label="操作人" align="center" sortable="custom" :sort-orders="['ascending','descending']"
            min-width="160" prop="name"></el-table-column>
          <el-table-column label="操作内容" align="left" sortable="custom" :sort-orders="['ascending','descending']"
            min-width="320" prop="content"></el-table-column>
          <el-table-column label="操作时间" align="left" sortable="custom" :sort-orders="['ascending','descending']"
            min-width="320" prop="time"></el-table-column>
          <el-table-column label="操作" align="center" min-width="180">
            <template slot-scope="row">
              <el-button size="mini" type="primary" icon="el-icon-edit" @click="editLog(row)">编辑</el-button>
              <el-button size="mini" type="danger" icon="el-icon-delete" @click="deleteLog(row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!-- 分页栏 -->
      <div class="pagination_box">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage"
          :page-sizes="[4, 8, 12]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper"
          :total="totalItems">
        </el-pagination>
      </div>
    </div>
    <!-- 新增日志对话框 -->
    <div>
      <el-dialog title="新增日志" :visible.sync="addDialogFormVisible" width="320px"
        :before-close="((done)=>{closeDialog('addLogForm',done)})">
        <el-form :model="addLogForm" label-position="right" label-width="55px" ref="addLogForm"
          :rules="addLogFormRules">
          <el-form-item label="名称" prop="name">
            <el-input v-model="addLogForm.name" autocomplete="off" clearable size="small"
              placeholder="请输入名称"></el-input>
          </el-form-item>
          <el-form-item label="操作内容" prop="content">
            <el-input v-model="addLogForm.content" type="textarea" :rows="4" autocomplete="off" clearable size="small"
              placeholder="请输入操作内容"></el-input>
          </el-form-item>
         <el-form-item label="时间" prop="time">
            <el-date-picker v-model="addLogForm.time" type="datetime" placeholder="选择日期时间" format="yyyy-MM-dd" value-format="yyyy-MM-dd">
            </el-date-picker>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button size="small" type="primary" @click="submitAddLogForm">确 定</el-button>
        </div>
      </el-dialog>
    </div>
    <!-- 编辑日志对话框 -->
    <div>
      <el-dialog title="编辑日志" :visible.sync="editDialogFormVisible" width="320px">
        <el-form :model="editLogForm" label-position="right" label-width="55px" ref="editLogForm"
          :rules="editLogFormRules">
          <el-form-item label="名称" prop="name">
            <el-input v-model="editLogForm.name" autocomplete="off" clearable size="small"
              placeholder="请输入名称"></el-input>
          </el-form-item>
          <el-form-item label="操作内容" prop="content">
            <el-input v-model="editLogForm.content" type="textarea" :rows="4" autocomplete="off" clearable size="small"
              placeholder="请输入操作内容"></el-input>
          </el-form-item>
          <el-form-item label="时间" prop="time">
            <el-date-picker v-model="editLogForm.time" type="datetime" placeholder="选择日期时间" format="yyyy-MM-dd" value-format="yyyy-MM-dd">
            </el-date-picker>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button size="small" type="primary" @click="submitEditLogForm">确 定</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'logs',
    components: {

    },
    data() {
      return {
        pickerOptions: {
                  shortcuts: [{
                    text: '今天',
                    onClick(picker) {
                      picker.$emit('pick', new Date());
                    }
                  }, {
                    text: '昨天',
                    onClick(picker) {
                      const date = new Date();
                      date.setTime(date.getTime() - 3600 * 1000 * 24);
                      picker.$emit('pick', date);
                    }
                  }, {
                    text: '一周前',
                    onClick(picker) {
                      const date = new Date();
                      date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
                      picker.$emit('pick', date);
                    }
                  }]
                },
        // 表格************************************************************************
        // 表格总数据
        tableData: [{
            id: 1,
            name: "管理员_2",
            content: "修改权限",
            time: "2023-6-8"
          },
          {
            id: 2,
            name: "管理员_2",
            content: "添加学生",
            time: "2023-6-7"
          },
          {
            id: 3,
            name: "管理员_4",
            content: "删除学生",
            time: "2023-6-8"
          },
          {
            id: 4,
            name: "管理员_3",
            content: "添加角色",
            time: "2023-6-6"
          },
        ],
        // 表格可检索内容 用于检索
        tableDataForm: {
          name: "",
          content: '',
          time: ''
        },
        // 新增日志表单************************************************************************
        // 新增日志对话框标识符
        addDialogFormVisible: false,
        // 新增日志表单
        addLogForm: {
          name: "",
          content: "",
          time: '',
        },
        // 新增日志验证
        addLogFormRules: {
          name: [{
            required: true,
            message: "请输入操作员",
            trigger: ["blur"]
          }],
          content: [{
            required: true,
            message: "请输入操作内容",
            trigger: ["blur"]
          }],
          time: [{
            required: true,
            message: "请输入操作时间",
            trigger: ["blur"]
          }],
        },
        // 编辑日志表单************************************************************************
        // 编辑日志对话框标识符
        editDialogFormVisible: false,
        // 新增日志表单
        editLogForm: {
          name: "",
          content: "",
          time: '',
        },
        // 新增日志验证
        editLogFormRules: {
          name: [{
            required: true,
            message: "请输入操作员",
            trigger: ["blur"]
          }],
          content: [{
            required: true,
            message: "请输入操作内容",
            trigger: ["blur"]
          }],
          time: [{
            required: true,
            message: "请输入操作时间",
            trigger: ["blur"]
          }],
        },
        // 默认选中的节点
        defaultKeys: [],
        // 搜索************************************************************************
        // 搜索关键字
        searchKey: "",
        // 搜索结果
        searchResult: [],
        // 分页***********************************************************************
        // 采集设备表格前页数据
        tableDataEnd: [],
        // 当前页数
        currentPage: 1,
        // 表格展示的行数
        pageSize: 8,
        // 总行数
        totalItems: 0,
        // 当前行
        currentRow: 0,
        // 当前表格排序
        currentSort: null,
        // 其他***********************************************************************
      };
    },
    created() {
      // 请求表格数据
      this.getTableData(false)
    },
    mounted() {

    },
    methods: {
      // *********************************************************************************************************
      // 表格数据获取
      // *********************************************************************************************************
      // 请求表格数据 flag为是否还原表格状态
      getTableData(flag) {
        // TODO 获取表格数据
        this.totalItems = this.tableData.length
        this.handleCurrentChange(1)
      },
      // *********************************************************************************************************
      // 新增日志
      // *********************************************************************************************************
      // 添加日志
      addLog(row) {
        this.addDialogFormVisible = !this.addDialogFormVisible
      },
      // 提交添加日志表单
      submitAddLogForm() {
        this.$refs['addLogForm'].validate((valid) => {
          if (valid) {
            this.tableData.push(JSON.parse(JSON.stringify(this.addLogForm)))
            this.totalItems = this.tableData.length
            this.handleCurrentChange(1)
            this.addDialogFormVisible = false
            this.$refs['addLogForm'].resetFields();
          } else {
            return false;
          }
        });
      },
      // *********************************************************************************************************
      // 编辑日志
      // *********************************************************************************************************
      // 编辑日志
      editLog(row) {
        this.editDialogFormVisible = !this.editDialogFormVisible
        this.currentRow = row.$index
        this.editLogForm = JSON.parse(JSON.stringify(row.row))
      },
      // 提交编辑日志表单
      submitEditLogForm() {
        try {
          // 执行更新日志数据的操作
          // 更新成功，可以进行一些操作，如关闭编辑对话框等
          this.editDialogFormVisible = !this.editDialogFormVisible;

          // 更新表格数据
          const index = this.currentRow;
          if (index !== -1) {
            // this.tableData.splice(index, 1, this.editLogForm);
            this.$set(this.tableData, index, this.editLogForm);
          }
          // 自动刷新表格数据
          this.getTableData(false);
        } catch (error) {
          // 处理更新失败的情况，可以进行一些错误处理操作
          console.error('更新日志数据失败:', error);
        }
      },
      // *********************************************************************************************************
      // 删除日志
      // *********************************************************************************************************
      // 删除日志
      deleteLog(row) {
        const index = this.tableData.indexOf(row.row);
        if (index !== -1) {
          this.tableData.splice(index, 1);
          this.totalItems = this.tableData.length;
          this.handleCurrentChange(this.currentPage);
        }
      },

      // *********************************************************************************************************
      // 表格排序功能
      // *********************************************************************************************************
      // 表头某列点击排序
      onSortChange({
        prop,
        order
      }) {
        this.currentSort = {
          prop,
          order
        }
        if (this.searchKey === "") {
          this.tableData.sort(this.compare(prop, order));
        } else {
          this.searchResult.sort(this.compare(prop, order));
        }
        this.handleCurrentChange(this.currentPage)
      },
      // 排序比较
      compare(propertyName, sort) {
        return function(obj1, obj2) {
          var value1 = obj1[propertyName]
          var value2 = obj2[propertyName]
          if (typeof value1 === 'string' && typeof value2 === 'string') {
            const res = value1.localeCompare(value2, 'zh')
            return sort === 'ascending' ? res : -res
          } else {
            if (value1 <= value2) {
              return sort === 'ascending' ? -1 : 1
            } else if (value1 > value2) {
              return sort === 'ascending' ? 1 : -1
            }
          }
        }
      },
      // *********************************************************************************************************
      // 表格搜索功能
      // *********************************************************************************************************
      // 关键字变化或输入框失焦后的操作
      searchKeyChange(tableData, key) {
        if (key !== "") {
          this.searchResult = tableData.filter((obj) => this.searchCheck(obj, this.tableDataForm))
          this.totalItems = this.searchResult.length
        } else {
          this.totalItems = this.tableData.length
        }
        this.handleCurrentChange(1)
      },
      // 判断对象中是否包含搜索关键字 返回布尔值
      searchCheck(obj, form) {
        var flag = false
        for (let i = 0; i < Object.getOwnPropertyNames(obj).length - 1; i++) {
          // 获取对象的第i个key值
          var originalKey = Object.getOwnPropertyNames(obj)[i]
          for (let j = 0; j < Object.getOwnPropertyNames(form).length - 1; j++) {
            // 获取表格样式的第j个key值
            var targetKey = Object.getOwnPropertyNames(form)[j]
            // 如果key值匹配 则进行搜索
            if (originalKey === targetKey) {
              var value = Object.values(obj)[i]
              // 判断是否是数组
              if (Array.isArray(value)) {
                // 如果是数组 则遍历数组中的元素 调用searchCheck返回布尔值
                for (let k = 0; k < value.length; k++) {
                  flag = flag || this.searchCheck(value[k], Object.values(form)[j][0])
                }
                break
              }
              // 判断是否是对象
              else if (Object.prototype.toString.call(value) === '[object Object]') {
                // 如果是对象 则遍历对象元素 调用searchCheck返回布尔值
                flag = flag || this.searchCheck(value[k], Object.values(form)[j])
                break
              }
              // 判断是否是数字
              else if (typeof(Object.values(obj)[i]) === "number") {
                value = Object.values(obj)[i].toString()
              }
              // 判断是否是字符串
              else if (typeof(Object.values(obj)[i]) === "string") {
                value = Object.values(obj)[i]
              } else {
                break;
              }
              // 判断是否和关键词匹配
              flag = flag || value.toLowerCase().includes(this.searchKey.toLowerCase())
            }
          }
        }
        return flag
      },
      // *********************************************************************************************************
      // 分页功能
      // *********************************************************************************************************
      //监控当前页码 页码变化后 重新选取当前页的数据
      currentChangePage(list) {
        // from：当前页的第一行数据在list中的序号  to：下一页的第一行数据在list中的序号
        let from = (this.currentPage - 1) * this.pageSize;
        let to = this.currentPage * this.pageSize;
        this.tableDataEnd = [];
        for (; from < to; from++) {
          if (list[from]) {
            this.tableDataEnd.push(list[from]);
          }
        }
      },
      //每页展示的行数变化后的操作
      handleSizeChange(val) {
        this.pageSize = val;
        this.handleCurrentChange(1);
      },
      //页码变化后的操作
      handleCurrentChange(val) {
        this.currentPage = val;
        // 判断是否在搜索
        if (this.searchKey === "") {
          this.currentChangePage(this.tableData);
        } else {
          this.currentChangePage(this.searchResult);
        }
      },
      // *********************************************************************************************************
      // 其他
      // *********************************************************************************************************
      // 关闭对话框
      closeDialog(ref, done) {
        this.$refs[ref].resetFields();
        done()
      },
    }
  };
</script>

<style lang="less" scoped>
  .main_box {
    border-radius: 8px 8px 8px 8px;
    box-shadow: 0 2px 10px 0 rgb(0 0 0 / 10%);
  }

  .top_box {
    text-align: right;
    background-color: #fff;
    padding: 10px 20px;
    border-bottom: 1px solid #E9EEF7;
    border-radius: 8px 8px 0px 0px;

    .el-input {
      width: 240px;
      margin-left: 10px;
    }

    .el-input .el-button {
      width: 40px;
      padding: 0;
    }
  }

  .table_box {
    background-color: #fff;
    padding: 10px 20px;

    /deep/ .el-table__header tr th.el-table__cell {
      color: #515a6e;
      background-color: #f8f8f9;
      padding: 8px 0;

      .cell {
        height: 34px;
        line-height: 34px;
      }
    }

    /deep/ .el-table__expanded-cell {
      padding: 20px 30px;
      background-color: #fcfcfc;
    }

    /deep/ tr:has(.el-table__expanded-cell) {
      background-color: #fcfcfc;
    }
  }

  .pagination_box {
    padding: 0px 20px 10px 20px;
    text-align: center;
    background-color: #fff;
    border-radius: 0px 0px 8px 8px;
  }

  /deep/ .el-dialog {
    border-radius: 8px 8px 8px 8px;
  }

  /deep/ .el-dialog__header {
    height: 50px;
    line-height: 50px;
    padding: 0 30px 0 30px;
    border-bottom: 1px solid #e0e0e0;

    .el-dialog__title {
      color: #666;
      font-size: 18px;
      font-weight: 700;
    }
  }

  /deep/ .el-dialog__body {
    padding: 15px 20px 0 20px;
  }

  /deep/ .el-dialog__footer {
    padding-top: 10px;
  }

  .el-dialog .el-button {
    width: 100%;
  }

  .el-form {
    width: 100%;
    margin: 0 auto;

    .el-form-item {
      margin-bottom: 10px;

      /deep/ .el-textarea {
        margin: 4px 0;
      }

      /deep/ textarea {
        font-family: Arial;
      }
    }

    /deep/ .el-form-item__error {
      padding-top: 0;
    }
  }

  /deep/ .el-form-item__label {
    color: #666;
  }

  .el-tag {
    margin: 7px;
  }

  .bdtop {
    border-top: 1px solid #eee;
  }

  .bdbottom {
    border-bottom: 1px solid #eee;
  }

  .vcenter {
    display: flex;
    align-items: center;
  }

  .set-role-dialog .el-form-item {
    height: 500px;
    overflow-y: auto;
  }
</style>
